<template>
    <div class="sb">
        <h4 class="sb__title" v-text="$ml.get('pixOFOrderReviewTitle')" tabindex="0" />
        <div class="sb__bank">
            <img :src="selectedBank.customerFriendlyLogoUri" :alt="'Logo ' + selectedBank.organizationName" />
            <span v-text="selectedBank.organizationName" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            selectedBank: {
                type: Object,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .sb {
        width: 100%;

        &__title {
            font-size: 16px;
            font-weight: 700;
        }
        &__bank {
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1.5px solid #B8C1CC;

            img {
                width: 40px;
                height: 40px;
                margin-right: 12px;
            }

            span {
                color: #2F363E;
                font-size: 16px;
            }
        }
    }
</style>
